function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "clock");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "UniCafe-PWA-Layouts-MVP",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Info",
  transform: "translate(-32.000000, -376.000000)",
  stroke: "#155C28"
}, /*#__PURE__*/React.createElement("g", {
  id: "Button/Area-Selection",
  transform: "translate(10.000000, 359.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "clock",
  transform: "translate(23.000000, 18.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.5,0 C14.7467143,0 19,4.25328571 19,9.5 C19,14.7467143 14.7467143,19 9.5,19 C4.25328571,19 0,14.7467143 0,9.5 C0,4.25328571 4.25328571,0 9.5,0 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 9.5,
  y1: 9.5,
  x2: 9.5,
  y2: 6,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 9.5,
  y1: 10,
  x2: 14.5,
  y2: 11.5,
  id: "Path"
})))));

var SvgClock = function SvgClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock.c7ad639f.svg";
export { ForwardRef as ReactComponent };